import {
  Component,
  Input,
  OnInit
} from '@angular/core';

import { TranslateService }  from '@ngx-translate/core';
import { UIRouter }          from '@uirouter/core';

import googleSsoIcon from 'icons/google-sso.svg';

import { ConfirmService }   from '../messages/confirm/confirm.service';
import { GoogleSsoService } from './google-sso.service';
import { JsonService }      from '../core/services/json.service';
import { MessagesService }  from '../messages/messages.service';
import { UserModel }        from '../users/models/user';

@Component({
  selector   : 'wor-google-sso-settings',
  template: require('./google-sso.settings.component.html')
})
export class GoogleSsoSettingsComponent implements OnInit {
  @Input() user : UserModel;

  public googleSsoIcon : string  = googleSsoIcon;
  public isSsoEnabled  : boolean = false;

  constructor (
    private confirmService   : ConfirmService,
    private googleSsoService : GoogleSsoService,
    private jsonService      : JsonService,
    private messagesService  : MessagesService,
    private router           : UIRouter,
    private translateService : TranslateService
  ) {}

  ngOnInit () : void {
    this.googleSsoService.getClientCredentials()
    .then(credentials => {
      this.isSsoEnabled = !!credentials?.client_id;
    })
    .catch(() => {
      this.isSsoEnabled = false;
    });

    const params = this.jsonService.getQueryParameters();

    if ( params.google_link_success ) {
      this.messagesService.show(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.GOOGLE_SSO.LINKED'), 'success');

      this.router.stateService.go('app.user-settings', {
        google_link_success: null,
        google_link_error  : null
      }, {
        inherit: false,
        reload : false
      });
    }
    else if ( params.google_link_error ) {
      this.messagesService.error({ message: params.google_link_error });

      this.router.stateService.go('app.user-settings', {
        google_link_success: null,
        google_link_error  : null
      }, {
        inherit: false,
        reload : false
      });
    }
  }

  isUserLinked () : boolean {
    return !!this.user?.google_id;
  }

  link () : void {
    this.googleSsoService.getLinkUrl()
    .then(url => window.location.assign(url))
    .catch(err => this.messagesService.error(err));
  }

  unlink () : void {
    this.confirmService.generic(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.GOOGLE_SSO.CONFIRM_UNLINK'))
    .then(() => this.googleSsoService.unlink())
    .then(() => {
      this.messagesService.show(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.GOOGLE_SSO.UNLINKED'), 'success');

      this.router.stateService.reload();
    })
    .catch(( err : any ) => {
      if ( err !== 'cancel' ) {
        this.messagesService.error(err);
      }
    });
  }
}
